import React, { useState, useEffect } from 'react';
import BuyerPersonaQuiz from '../buyerPersona/BuyerPersonaQuiz';
import BuyerPersonaResult from '../buyerPersona/BuyerPersonaResult';

const OnboardingBuyerPersonaModal = ({ isOpen, onClose, onComplete }) => {
    const [currentView, setCurrentView] = useState('quiz');
    const [buyerPersona, setBuyerPersona] = useState(null);

    // Efecto para controlar el scroll del body
    useEffect(() => {
        if (isOpen) {
            // Guarda la posición actual del scroll
            const scrollY = window.scrollY;

            // Añade los estilos para prevenir el scroll
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflowY = 'hidden';
        } else {
            // Recupera la posición del scroll y restaura los estilos
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflowY = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        // Limpieza al desmontar
        return () => {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflowY = '';
        };
    }, [isOpen]);

    const handleQuizComplete = (result) => {
        setBuyerPersona(result);
        setCurrentView('result');
    };

    const handleResultClose = () => {
        onComplete(buyerPersona);
        handleClose();
    };

    const handleClose = () => {
        setCurrentView('quiz');
        setBuyerPersona(null);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed z-50 inset-0 overflow-hidden bg-gray-500 bg-opacity-75">
            <div className="flex items-stretch md:items-center justify-center min-h-screen">
                {/* Modal Container */}
                <div className="relative w-full h-full md:h-auto md:max-h-[90vh] md:w-[90vw] md:max-w-4xl bg-gray-50 md:m-8 md:rounded-xl shadow-xl flex flex-col">
                    {/* Header - Sticky */}
                    <div className="flex-shrink-0 bg-white px-4 sm:px-6 py-4 border-b border-gray-200">
                        <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
                            {currentView === 'quiz' ? '¡Descubre a tu Cliente Estrella! 🌟' : '¡Eureka! Aquí está tu Análisis 🎯'}
                        </h3>
                        <p className="mt-1 text-sm text-gray-500">
                            {currentView === 'quiz'
                                ? 'Responde estas preguntas para entender mejor a tu cliente ideal'
                                : 'Revisa el perfil de tu cliente ideal'
                            }
                        </p>
                    </div>

                    {/* Content - Scrollable */}
                    <div className="flex-1 overflow-y-auto">
                        {currentView === 'quiz' ? (
                            <div className="h-full">
                                <div className="p-4 sm:p-6 bg-white shadow-sm mb-4">
                                    <p className="text-gray-600 text-sm sm:text-base">
                                        ¡Hey! 👋 Aunque seamos PetitPrime, pensamos a lo grande. Vamos a crear el perfil de tu cliente ideal
                                        para que tu marketing sea tan preciso como un francotirador. Con esta info, tu copiloto de marketing
                                        podrá ayudarte con todo: desde atraer nuevos clientes hasta convertirlos en fans incondicionales de tu marca.
                                        ¿Listo para rockear tu marketing? 🚀
                                    </p>
                                </div>
                                <div className="px-4 sm:px-6 pb-6">
                                    <BuyerPersonaQuiz
                                        mode="create"
                                        onComplete={handleQuizComplete}
                                        onClose={handleClose}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="p-4 sm:p-6">
                                <BuyerPersonaResult
                                    result={buyerPersona}
                                    onClose={handleResultClose}
                                    showNextStepButton={true}
                                    nextStepButtonText="¡Siguiente Paso en tu Aventura de Marketing! →"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingBuyerPersonaModal; 